import { locale } from "../locale";
import type { Smartplug2 } from "./sp2";

function checkConnection(sp2: Smartplug2): string {
	if (sp2.ConnectionLost)
		return locale.string({
			enGB: "Device offline",
			deDE: "Gerät offline",
			frFR: "Appareil hors ligne",
			svSE: "Enhet offline",
		});

	return "";
}

function checkConsumption(sp2: Smartplug2): string {
	if (
		sp2.ConsumptionNotification.Enabled &&
		sp2.ConsumptionNotification.Triggered
	)
		return locale.string({
			enGB: "Consumption exceeded threshold",
			deDE: "Last außerhalb des erwarteten Intervalls",
			frFR: "Charge en dehors de l'intervalle prévu",
			svSE: "Belastning utanför förväntat intervall",
		});

	return "";
}

function checkLoad(sp2: Smartplug2): string {
	if (!sp2.TargetConfig.LoadAlarm.Enabled) {
		return "";
	}

	if (sp2.Load < sp2.TargetConfig.LoadAlarm.Lower) {
		return locale.string({
			enGB: "Load under the expected load",
			deDE: "Last unter dem erwarteten Wert",
			frFR: "Charge inférieure à la charge prévue",
			svSE: "Belastning under förväntad belastning",
		});
	}

	if (sp2.Load > sp2.TargetConfig.LoadAlarm.Upper) {
		return locale.string({
			enGB: "Load over the expected load",
			deDE: "Last über dem erwarteten Wert",
			frFR: "Charge supérieure à la charge prévue",
			svSE: "Belastning över förväntad belastning",
		});
	}

	return "";
}

function checkPower(sp2: Smartplug2): string {
	if (
		sp2.PowerFailureNotification.Enabled &&
		sp2.PowerFailureNotification.Triggered
	)
		return locale.string({
			enGB: "Power failure",
			deDE: "Stromausfall",
			frFR: "Panne de courant",
			svSE: "Strömavbrott",
		});

	return "";
}

export function getSmartplug2Warnings(sp2: Smartplug2): string[] {
	return [
		checkConnection(sp2),
		checkConsumption(sp2),
		checkPower(sp2),
		checkLoad(sp2),
	].filter((text) => text !== "");
}
